import { instance } from '@/api/instances'
import { TIMELINE_TYPE } from '@/models/timeline'

const BASE_URL = personId => `persons/${personId}/assistance_summaries`

const getMemberSummary = async (store, personId) => {
  const url = BASE_URL(personId)

  try {
    const summary = await instance.get(url)

    store.commit('setSummary', { ...summary, personId })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'pillars/summary/getMemberSummary'
      },
      { root: true }
    )
  }
}

const getMemberClinicalBackgrounds = async (store, personId) => {
  const url = BASE_URL(personId)

  try {
    const clinicalBackgrounds = await instance.get(
      `${url}/clinical_backgrounds`
    )

    store.commit('setClinicalBackgrounds', {
      ...clinicalBackgrounds,
      personId
    })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'pillars/summary/getMemberClinicalBackgrounds'
      },
      { root: true }
    )
  }
}

const getMemberTriage = async (store, { channelId, personId }) => {
  const url = BASE_URL(personId)

  try {
    const triage = await instance.get(`${url}/triage/${channelId}`)

    store.commit('setTriage', {
      ...triage,
      personId
    })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'pillars/summary/getMemberTriage'
      },
      { root: true }
    )

    throw error
  }
}

const getMemberHistory = async (store, personId) => {
  const params = {
    range: [0, 9],
    filter: {
      type: [
        TIMELINE_TYPE.APPOINTMENT_DEFAULT,
        TIMELINE_TYPE.THIRD_PARTY_APPOINTMENT_EMERGENCY,
        TIMELINE_TYPE.TIT_EMERGENCY,
        TIMELINE_TYPE.APPOINTMENT_ASSISTANCE_CARE,
        TIMELINE_TYPE.APPOINTMENT_ON_SITE,
        TIMELINE_TYPE.APPOINTMENT_TEST_COLLECT,
        TIMELINE_TYPE.APPOINTMENT_COMMUNITY,
        TIMELINE_TYPE.CLINICAL_RECORD
      ]
    }
  }
  try {
    const { timelineItems } = await instance.get(
      `persons/${personId}/v2/timeline`,
      {
        params
      }
    )
    store.commit('setTimeline', timelineItems)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'pillars/summary/getMemberTriage'
      },
      { root: true }
    )

    throw error
  }
}

const getLiteProfile = async (store, personId) => {
  store.commit('setLiteProfile', undefined)
  if (!personId) {
    return
  }
  try {
    const response = await instance.get(`persons/${personId}/light`)

    store.commit('setLiteProfile', response)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'fetchLiteProfile' },
      { root: true }
    )
  }
}

const clearSummary = store => {
  store.commit('setTimeline', undefined)
  store.commit('setTriage', undefined)
  store.commit('setClinicalBackgrounds', undefined)
  store.commit('setSummary', undefined)
  store.commit('setLiteProfile', undefined)
}

export default {
  getMemberTriage,
  getMemberHistory,
  getMemberSummary,
  getMemberClinicalBackgrounds,
  getLiteProfile,
  clearSummary
}
